import { RJSFSchema, StrictRJSFSchema, TitleFieldProps } from '@rjsf/utils';

import { REQUIRED_FIELD_SYMBOL } from 'dashboard/views/DashboardSARShowView/FormSAR/rjsf/FormComponents/constants';
import { Label } from 'design-system/components/Text';

/** The `TitleField` is the template to use to render the title of a field
 *
 * @param props - The `TitleFieldProps` for this component
 */
export function TitleFieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  props: TitleFieldProps<T, S, F>,
) {
  const { title, required } = props;
  return (
    <Label size='lg' weight='bold'>
      {title}
      {required ? REQUIRED_FIELD_SYMBOL : null}
    </Label>
  );
}
